var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquipmentIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0585 3.52016L25.0038 3.65005L19.7255 16.1369L15.0775 15.9359C13.9685 15.8879 12.897 16.1061 11.9144 16.5359L15.1093 8.77675L15.1827 8.591L15.3099 8.29421C15.3474 8.18247 15.3849 8.07073 15.4379 7.97856C17.8215 2.357 20.2914 1.16018 25.0585 3.52016Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9158 3.30215L26.8572 3.43902L21.1869 16.5979H15.6144C14.2849 16.5979 13.014 16.8716 11.8604 17.3604L15.282 9.18747L15.3603 8.99194L15.4971 8.6791C15.5362 8.56179 15.5753 8.44447 15.634 8.34671C18.1954 2.42229 21.0892 1.07316 26.9158 3.30215Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4552 16.9915C36.5754 16.7177 35.6368 16.6004 34.6983 16.6004H21.1875L26.8577 3.44156L26.9164 3.30469C27.2097 3.40245 27.4834 3.53932 27.7767 3.65663L32.0978 5.47502C34.5028 6.4722 36.1843 7.50849 37.201 8.75985C37.3966 8.99448 37.553 9.20956 37.6899 9.46374C37.8658 9.73748 38.0027 10.0112 38.0809 10.3045C38.1591 10.4805 38.2178 10.6564 38.2569 10.8129C38.7848 12.4553 38.472 14.4692 37.4552 16.9915Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2453 26.1397V29.9526C44.2453 30.3437 44.2257 30.7347 44.2062 31.1258C43.8346 37.9499 40.0217 41.3913 32.787 41.3913H17.5354C17.0661 41.3913 16.5968 41.3522 16.1471 41.2935C9.92914 40.8829 6.60507 37.5588 6.19445 31.3409C6.13579 30.8912 6.09668 30.4219 6.09668 29.9526V26.1397C6.09668 22.2095 8.48219 18.8267 11.8845 17.3602C13.0577 16.8714 14.3091 16.5977 15.6387 16.5977H34.7228C35.6809 16.5977 36.6195 16.7345 37.4798 16.9887C41.3709 18.1815 44.2453 21.8184 44.2453 26.1397Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2766 29.2656V30.9667C28.2766 32.408 26.9359 33.5728 25.2851 33.5728C23.6343 33.5728 22.2852 32.408 22.2852 30.9667V29.2656C22.2852 30.7069 23.6259 31.7292 25.2851 31.7292C26.9359 31.7292 28.2766 30.6985 28.2766 29.2656Z",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2752 26.9571C28.2752 27.376 28.1579 27.7615 27.9568 28.0967C27.4624 28.9095 26.4484 29.4207 25.2753 29.4207C24.1021 29.4207 23.0882 28.9011 22.5938 28.0967C22.3927 27.7615 22.2754 27.376 22.2754 26.9571C22.2754 26.2364 22.6106 25.5912 23.1469 25.1219C23.6915 24.6443 24.4373 24.3594 25.2669 24.3594C26.0965 24.3594 26.8423 24.6526 27.387 25.1219C27.94 25.5828 28.2752 26.2364 28.2752 26.9571Z",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2766 26.9615V29.2659C28.2766 30.7072 26.9359 31.7296 25.2851 31.7296C23.6343 31.7296 22.2852 30.6989 22.2852 29.2659V26.9615C22.2852 25.5202 23.6259 24.3555 25.2851 24.3555C26.1147 24.3555 26.8605 24.6487 27.4052 25.118C27.9415 25.5873 28.2766 26.2409 28.2766 26.9615Z",
    stroke: "#1552E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2825 9.1875L11.8608 17.3605C8.45865 18.8269 6.07324 22.2095 6.07324 26.1396V20.4107C6.07324 14.8577 10.0229 10.2238 15.2825 9.1875Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2378 20.4095V26.1384C44.2378 21.8368 41.3832 18.1805 37.4727 17.0073C38.4894 14.4655 38.7827 12.4711 38.2939 10.8091C38.2548 10.6332 38.1961 10.4572 38.1179 10.3008C41.7547 12.1778 44.2378 16.0297 44.2378 20.4095Z",
    stroke: "#081E54",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0824 38.6042C18.0824 39.2075 18.007 39.792 17.8562 40.3576C17.6865 41.1118 17.3848 41.8471 16.9889 42.4882C15.688 44.6753 13.2934 46.1459 10.5407 46.1459C8.59874 46.1459 6.84528 45.4105 5.52549 44.2039C4.95986 43.7136 4.46963 43.1292 4.09254 42.4882C3.39494 41.3569 2.99902 40.0183 2.99902 38.6042C2.99902 36.5679 3.80977 34.7014 5.12956 33.3439C6.50592 31.9298 8.42905 31.0625 10.5407 31.0625C12.7655 31.0625 14.7829 32.0241 16.1404 33.5701C17.3471 34.9088 18.0824 36.6811 18.0824 38.6042Z",
    fill: "#A020FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3549 38.5703H7.73633",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5459 35.8086V41.446",
    stroke: "white",
    strokeWidth: 1.33929,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentIcon3);
export default __webpack_public_path__ + "static/media/equipmentIcon3.9392ccbe6b147309f5c4c4fecb49b9fc.svg";
export { ForwardRef as ReactComponent };